import React, { useRef, useState, useEffect } from "react";
import { Singleton } from "../services/Singleton";
import { AdminService } from "../services/AdminService";
import { encryptData } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";

import { Modal } from "../../modules/theme/Component/Modal";
import { ActivateAccountLdap } from "./ActivateAccountLdap";
import { env } from "../../env";
import useFetch from "../services/dataBean/fetch/useFetch";
import { toast } from "react-toastify";
import { ValidationOtpRecognized } from "../../modules/theme/Component/ValidationOTP/ValidationOtpRecognized";
import "./Login2.css";

interface ILogin {
  setIsLogged: any;
}

interface metaDataProps {
  fingerprint: string;
  host: string;
  ip: string;
  language: string;
  serverTime: string;
  userAgent: string;
  CurrentDate: string;
}

export const Login2 = (props: ILogin) => {
  const custosClient = env.CUSTOM_CLIENT ?? false;
  const tfa = env.TF_AUTENTICATION ?? false;
  const isTest = env.TEST_ENVIROMENT ?? false;

  const { getService } = useFetch();

  const [logo, setLogo] = useState("assets/images/core/ERP.png");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [user, setUser] = useState({ user: "", pass: "", tipo: "ldap" });

  const [yek, setYek] = useState<string>("");
  const [tipoLogin, setTipoLogin] = useState<any[]>([]);
  const [account, setAccount] = useState<any>({});
  const [esquema, setEsquema] = useState<any>({});
  const [login, setLoign] = useState<any>("");

  const [metaData, setMetaData] = useState<Partial<metaDataProps>>({});
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const otpValidator = useRef<any>(null);

  const _AdminService = new AdminService();
  const _single = Singleton.getInstance();
  const navigate = useNavigate();

  const [modal, setModal] = useState<any>({
    name: "LDAP",
    tabIndex: -1,
    view: false,
    btnClose: true,
    btnSubmit: false,
    format: "modal-lg",
  });

  useEffect(() => {
    if (custosClient) setLogo("./conf/custom/image/logo.png");

    getService("/quickdataerp/ping")
      .then((resp) => setMetaData(resp))
      .catch((err) => toast.error(err));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setYek(_single.encrypKey);
      getLoginTypes();
    }, 1000);
  }, []);

  useEffect(() => {
    tipoLogin.forEach((element: any) => {
      if (element.DataBeanProperties.AuthType === login) {
        setEsquema(element.DataBeanProperties);
      }
    });
  }, [login, tipoLogin]);

  const getLoginTypes = () => {
    _single.spinner(true);
    _AdminService.getLoginTypes().subscribe((resp: any) => {
      if (resp.DataBeanProperties.ObjectValue) {
        const tipos = resp.DataBeanProperties.ObjectValue;
        setTipoLogin(tipos);
        if (tipos.length > 0) setEsquema(tipos[0].DataBeanProperties);
      }
      _single.spinner(false);
    });
  };

  const getKey = () => {
    _AdminService.securitymanager().subscribe((resp: any) => {
      if (resp.DataBeanProperties.ObjectValue) {
        _single.setSessionItem("yek", resp.DataBeanProperties.ObjectValue.DataBeanProperties.Key);
        _single.setSessionItem("yekDate", resp.DataBeanProperties.ObjectValue.DataBeanProperties.Name);
        setYek(resp.DataBeanProperties.ObjectValue.DataBeanProperties.Key);
      }
    });
  };

  // ✅ IMPORTANTE: NO mutar el state
  const updateUser = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const loginUser = () => {
    if (isSubmitting) return;

    if (yek === "") {
      getKey();
    }

    if (user.user.trim() === "" || user.pass.trim() === "") {
      setErrorMessage("Usuario o contraseña no pueden estar vacíos");
      return;
    }

    setErrorMessage("");
    setIsSubmitting(true);
    _single.spinner(true);

    _AdminService
      .login(
        esquema.AuthType,
        encryptData(user.user),
        encryptData(user.pass),
        esquema.Ldap,
        metaData.ip,
        metaData.fingerprint
      )
      .subscribe({
        next: (respLog: any) => {
          const resp = respLog?.data;

          const token = respLog?.headers?.["authorization"] || respLog?.headers?.["Authorization"];
          if (token) {
            _single.setSessionItem("auth", token);
          }

          _single.setLoginType(esquema.AuthType);

          if (!resp) {
            setErrorMessage("Usuario no autorizado");
            setIsSubmitting(false);
            _single.spinner(false);
            return;
          }

          if (resp.DataBeanProperties?.hasOwnProperty("ErrorMessage")) {
            props.setIsLogged(false);
            setErrorMessage(resp.DataBeanProperties.ErrorMessage);
            getKey();
            setIsSubmitting(false);
            _single.spinner(false);
            return;
          }

          if (!resp.DataBeanProperties?.ObjectValue) {
            setErrorMessage("Datos inválidos");
            setIsSubmitting(false);
            _single.spinner(false);
            return;
          }

          const rest: any = resp.DataBeanProperties.ObjectValue;

          if (rest.DataBeanProperties.State === 8) {
            setModal({ ...modal, view: true });
            setIsSubmitting(false);
            _single.spinner(false);
            return;
          }

          if (rest.DataBeanProperties.IDAccount >= 0 && rest.DataBeanProperties.IDSession >= 0) {
            _single.startSesion(rest.DataBeanProperties.Account.DataBeanProperties);
            props.setIsLogged(true);

            if (_single.getAccountID() === 0) {
              navigate("/system");
            } else {
              _single.setMetaDataUser({ ...metaData, currentDate: new Date(), IDAccount: _single.getAccountID() });
              _single.setSessionItem("userName", user.user);

              if (tfa) {
                if (otpValidator.current) otpValidator.current.openOTPModal("Validacion de Identidad");
              } else {
                navigate("/app");
              }
            }
            setIsSubmitting(false);
            _single.spinner(false);
            return;
          }

          setErrorMessage("Usuario o contraseña inválidos");
          setIsSubmitting(false);
          _single.spinner(false);
        },
        error: (err: any) => {
          console.error("Login error:", err);
          setErrorMessage("Error de conexión. Intenta de nuevo.");
          setIsSubmitting(false);
          _single.spinner(false);
        }
      });
  };

  return (
    <>
      <div className={`auth-page-wrapper${isTest ? " test-environment-auth-page" : ""}`}>
        <div className="auth-page-content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-sm-10 col-md-10 col-lg-6 col-xl-6">
                {!custosClient && (
                  <div className="row justify-content-center simbolds-container">
                    <div className="col-auto text-center">
                      <img src="assets/images/core/simbolds.png" className="img-fluid simbolds-img" alt="" />
                    </div>
                  </div>
                )}
                {/* LOGO */}
                <div className="image-container">
                  <img src={logo} className="img-login" alt="Logo" />
                </div>

                <div className="container-loginnew py-3">
                  {/* SIMBOLO SUPERIOR (DESKTOP) */}

                  <h2 className="login-title">Iniciar sesión</h2>

                  {/* MENSAJE DE ERROR */}
                  {errorMessage && (
                    <div className="alert alert-danger py-2 mb-3 text-center" role="alert">
                      {errorMessage}
                    </div>
                  )}

                  {/* FORM */}
                  <div className="row g-3 login-form">

                    <div className="col-12 col-md-6">
                      <label className="collabel">USUARIO</label>
                      <input
                        type="text"
                        className="form-control"
                        name="user"
                        placeholder="Ingrese usuario"
                        onChange={updateUser}
                        onKeyDown={(e) => e.key === "Enter" && !isSubmitting && loginUser()}
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="collabel">TIPO DE USUARIO</label>
                      <select
                        className="form-select"
                        value={login}
                        onChange={(e) => setLoign(e.target.value)}
                        disabled={isSubmitting}
                      >
                        {tipoLogin.map((tipo: any) => (
                          <option
                            key={tipo.DataBeanProperties.AuthType}
                            value={tipo.DataBeanProperties.AuthType}
                          >
                            {tipo.DataBeanProperties.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="collabel">CONTRASEÑA</label>
                      <input
                        type="password"
                        className="form-control"
                        name="pass"
                        placeholder="Ingrese contraseña"
                        onChange={updateUser}
                        onKeyDown={(e) => e.key === "Enter" && !isSubmitting && loginUser()}
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="col-12">
                      <button
                        className="colbut w-100"
                        onClick={loginUser}
                        disabled={isSubmitting}
                        style={isSubmitting ? { opacity: 0.7, cursor: "not-allowed" } : {}}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            INGRESANDO...
                          </>
                        ) : (
                          "INGRESAR"
                        )}
                      </button>
                    </div>

                  </div>
                </div>

                {custosClient &&
                  <div className="watermark">
                    <a href="https://www.advantage.com.co/" target="_blank" rel="noopener noreferrer">@advantage.com.co</a>
                  </div>
                }
                {custosClient == false &&
                  <div className="row justify-content-center footer-brand">
                    <div className="col-auto text-center">
                      <p className="power">Powered by</p>
                      <img
                        src="assets/images/core/logoblancoamc.png"
                        className="imglog"
                        alt=""
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODAL LDAP */}
      {modal.view && (
        <Modal modal={modal} updateModal={setModal} eventModal={() => { }}>
          <h6>Actualizar Información de la cuenta</h6>
          <hr />
          <ActivateAccountLdap user={user.user} setAccount={setAccount} domain={esquema.Name} />
        </Modal>
      )}

      {/* OTP */}
      <ValidationOtpRecognized
        ref={otpValidator}
        onValidate={() => navigate("/app")}
        _text="Necesitamos validar tu identidad para ingresar"
      />
    </>
  );
};
